// Admin & blacklist configuration
// IMPORTANT: apiKey below must match API_KEY in public/api/blacklist_config.php

// Allowed admin wallet addresses (lowercase)
export const ADMIN_ADDRESSES = [
  '0x64f9c443773A7246ce14d127d171c77F3dBD58DE',
  '0x24190cd99a7ae1582fc2ddf07a08879ecf7ce2fc',
];

// Blacklist PHP API — served from the same origin as the React build
export const BLACKLIST_API = {
  get:    '/api/get_blacklist.php',
  add:    '/api/add_blacklist.php',
  remove: '/api/remove_blacklist.php',
  apiKey: '0xBf3aD7aA0E011C1279568B7Ec25b303b32C2b1EE',
};

export const isAdminAddress = (address) => {
  if (!address) return false;
  const lower = address.toLowerCase();
  return ADMIN_ADDRESSES.some((a) => a.toLowerCase() === lower);
};

export const isBlacklisted = (address, list) => {
  if (!address || !Array.isArray(list)) return false;
  return list.includes(address.toLowerCase());
};
